import { TableCell, TableRow } from "@material-ui/core";
import pretty from "Shared/pretty";
import React from "react";
import { DPEmployeePayment, PaymentType } from "Shared/types/Payments";
import RelatedPaymentTableCell from "Components/Pages/UserProfile/UserPayments/RelatedPaymentTableCell/RelatedPaymentTableCell";
import useStyles from "./styles";

const UserPaymentRow = ({
  id,
  processedOn,
  paymentType,
  receivingAccount,
  payPeriodAmountCents,
  paymentMethod,
  feeAmountCents,
  relatedPayments,
}: DPEmployeePayment) => {
  const classes = useStyles();
  const payPeriodAmountClassName = paymentType.toLowerCase() as PaymentType;

  return (
    <TableRow>
      <TableCell>
        {pretty.date(processedOn)}
      </TableCell>
      <TableCell className={classes.type}>{paymentType}</TableCell>
      <TableCell align="right">
        {pretty.receivingAccount(receivingAccount)}
      </TableCell>
      <TableCell align="right" className={classes[payPeriodAmountClassName]}>
        {pretty.dollar(payPeriodAmountCents)}
      </TableCell>
      <TableCell align="right">{paymentMethod}</TableCell>
      <TableCell align="right">{pretty.dollar(feeAmountCents)}</TableCell>
      <RelatedPaymentTableCell
        id={id}
        processedOn={processedOn}
        paymentType={paymentType}
        receivingAccount={receivingAccount}
        payPeriodAmountCents={payPeriodAmountCents}
        paymentMethod={paymentMethod}
        feeAmountCents={feeAmountCents}
        relatedPayments={relatedPayments}
      />
    </TableRow>
  );
};

export default UserPaymentRow;
